export default "__VITE_ASSET__Ci2wXQ$N__"